/**
 * Auth module initialization for desktop app
 *
 * This file initializes the @littlebird/auth module with the desktop app's
 * environment variables. It must be imported before any other code that
 * uses the auth module.
 */

import { createAuthModule } from '@littlebird/auth-client';

import { getEnvVar } from '@/env';
import { authClientLogger } from '@/lib/logger';
// Initialize auth module with desktop app's validated env vars
// This must happen before any other auth module usage
createAuthModule({
  baseUrl: getEnvVar('VITE_API_URL'),
  auth0Domain: getEnvVar('VITE_AUTH0_DOMAIN'),
  auth0ClientId: getEnvVar('VITE_AUTH0_CLIENT_ID'),
  clientVersion: __APP_VERSION__,
  logger: authClientLogger,
});

export { createAuthContext, type AuthContext } from './auth-context';
export { setupAuthListeners } from './auth-listeners';
